
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { FontIcon } from "office-ui-fabric-react";
import { mergeStyleSets } from '@uifabric/merge-styles';

const classNames = mergeStyleSets({
    idBox: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'end'
    },

    ico: {
        marginRight: '1em'
    },

    attributesBox: {
        paddingTop: '1em',
    }
});

const UsekAttributesView = ({
    usekAttributes,
    usekId
}) => {

    return (
        <Stack verticalFill>
            <Stack.Item>
                <h3>Atributy úseku meze</h3>
            </Stack.Item>
            <Stack.Item className={classNames.idBox}>
                <FontIcon className={classNames.ico} iconName="GripperDotsVertical"></FontIcon>
                <div>UsekID: {usekId}</div>
            </Stack.Item>
            <Stack.Item className={classNames.attributesBox}>
                {usekAttributes}
            </Stack.Item>
        </Stack>
    )
}

export default UsekAttributesView;
